/**
 * @created on 2018/10/22
 * @author zengshaopeng
 **/

import './index.scss'
import { axios as $http, track } from 'cm'
import { track as tracks } from '@yxl/libs'
import api from './api'
import Bridge from '../../../frontend-lib/lib/Bridge'
import GetQueryString from '../../../public-resource/get-query/index'
import Reward from '../../../public-resource/components/reward/index'
import similarProblem from '../../../public-resource/components/similarProblem'
import Comment from '../../../public-resource/components/Commnet/index'
import levelPopup from '../../../public-resource/components/levelPopup'
import clockCardToast from '../../../public-resource/components/clockCardToast'
import { funFactory } from '../../../public-resource/libs/axios/requestSign'
import {
  linebreakReplace,
  GetRequest,
  objectToQueryString,
  throttle,
  getRunTime
} from '../../../public-resource/libs/utils/index'
import { versionfunegt, addQueryToUrl } from 'src/frontend-lib/tools/utils.js'

import { getRequestSign } from '../../../frontend-lib/tools/platformSign'
import { wxConfigOrigin } from 'src/frontend-lib/tools/utils'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'

import renderAnswerList from './render/answerList'
import renderQuestionList from './render/questionList'
import renderRankList from './render/rankList'
import renderRewardList from './render/rewardList'

import PsychicCoachList from './modules/psychicCoachList'
import HostSearchList from './modules/hotSearchList'
import TopicList from './modules/topicList'
import BranchList from './modules/branchList'
import SpecialList from './modules/specialList'

import monitor from 'src/frontend-lib/lib/monitor'
import allToApp from '@yxl/open-app'

// import vconsole from 'vconsole'
// new vconsole()

// 导入富文本CSS
$('head').append(
  '<link rel="stylesheet" href="https://static.xinli001.com/fe-app/style/theme-yixinli.css">'
)
;(function() {
  let qa = qa || {}

  const COMMENT = new Comment()
  const PROTOCOL = window.location.protocol

  let UAobj = window.$platform
  let unrewarded = UAobj.isWechat && UAobj.isiPhone
  let token = ''
  let IS_APP = window.$platform.isYixinliApp
  let myBridge = new Bridge()
  let isLike = false // 控制点赞
  let isFeel = false // 控制同感
  let isAttention = false // 控制关注
  let appToken = '' // app的token
  let urlparams = GetRequest()
  let sshzv = 0
  if (urlparams.sshzv == 1) {
    sshzv = 1
  }
  let getTokenLock = false
  let hasUserNotice = false
  let lastQuesId = '' // 最新问题id
  let adList = []

  let isQaHomeTab = true

  if (unrewarded) {
    $('.award-img').addClass('unrewarded')
  }
  // let loadMore = `<div class="loading-more"><span></span><span></span><span></span></div>`;
  // $('body').append(loadMore);
  // let loadMoreDiv = $('.loading-more');

  let envHost = window.location.protocol + getEnvHost(`//m.xinli001.com`)
  let safeDomain = wxConfigOrigin(
    require('../../../../yxlConfig.json'),
    'QA_ORIGIN',
    'm_safe'
  )

  if (IS_APP) {
    // window.refreshing = function() {
    //   console.log(window.location.href)
    // }
    // myBridge.call('allowJSControlRefresh', { isAllowed: 1 })
    $('.container').css('padding-top', 0)
    $('.rank').css('top', 0)
    // $('.author-tag').css('padding-top', '1px');
    // 客户端强制居中
    // if (UAobj.isAndroid) {
    //     $('.author-tag').css('padding-top', '3px');
    // }
    myBridge.call('getToken', { callbackName: 'loginOperation' })
    myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
    myBridge.call('setTitle', { title: '人生答疑馆' })
    console.log('setTitle 执行完毕')

    // app8.0及其以上，隐藏 .newTips
    let _version =
      window.$platform.yixinliAPPVersion || GetQueryString('_version')
    if (IS_APP && versionfunegt(_version, '8.0.0')) {
      let el = document.querySelector('.newTips')
      el && el.classList.add('hide-max')
    }

    window.Bridge = Bridge
    let $config = {
      link: window.location.href,
      imgUrl:
        'https://imgs.xinli001.com/public/picture/20240327/d1397dff3bdc4933adb3b9e5989d0d00.png',
      desc: '提问是一切的开始',
      title: '人生答疑馆',
      sharePageSource: '人生答疑管',
      sourcePage: '问答首页',
      itemName: '问答首页链接',
      isHideSendToChat: 0
    }
    window.myBrige = new Bridge({
      methods: [
        {
          method: 'topFuncBtn',
          callback(ops) {
            if (ops.name === 'shareReportBtn') {
              window.myBrige.call('shareReport', $config)
            }
          }
        }
      ]
    })

    // window.myBrige.call('setTitle', {
    //   title: 'document.title'
    // })

    window.myBrige.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })
  } else {
    $('.nav-header').css('display', 'block')
    setAppDialog()
  }

  window.yxl.stat.send({
    name: '问答-「主页」访问'
  })

  let body = document.querySelector('body')
  // body.addEventListener("click", function(e) {});
  body.addEventListener('touchend', function(e) {})
  // IOS 微信浏览器开启点击事件
  $('body>*').bind('click', function() {})

  var loadingDiv =
    '<div class="loadingDiv"><div class="mint-indicator-wrapper" style="padding: 15px;"><span class="mint-indicator-spin"><div class="mint-spinner-snake" style="border-top-color: rgb(204, 204, 204); border-left-color: rgb(204, 204, 204); border-bottom-color: rgb(204, 204, 204); height: 32px; width: 32px;"></div></span> <span class="mint-indicator-text" style="display: none;"></span></div></div>'
  $('body').append(loadingDiv)

  const lastReplayInfo = {
    replayEle: null,
    lastReplayId: null,
    answerId: null,
    replayNum: 0,
    content: null
  }

  function reply() {
    // if (window.baseInfo.user_id === lastReplayInfo.lastReplayId) {
    //     window.toast('不能回复自己！');
    //     let e = lastReplayInfo.replayEle
    //     e.attr('replayId', null);
    //     e.attr('placeholder', '回复评论');
    //     return;
    // }

    let $config = {
      title: '回复',
      placeholder:
        '一个感同身受的回应，有效的解决问题的方法，都是对提问者有用的回答',
      callback(content) {
        if (IS_APP) {
          // lastReplayInfo.content = content;
          // myBridge.call('showEditDialog', { callbackName: 'replayOperation', maxLength: 5000 });
          // myBridge.call('switchTitleBar', { 'isHidden': 1 })
          // myBridge.call('isPullRefreshEnable', { 'enable': 0 })
          // myBridge.call('setConfig', { isAllowedTitleAnimate: 0 })

          myBridge.call('switchTitleBar', {
            isHidden: 0
          })
          myBridge.call('isPullRefreshEnable', {
            enable: 1
          })
          myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
        }
        if (content) {
          lastReplayInfo.content = content
          window.replayOperation(content)
        }
      },
      max: 5000,
      skipApp: true,

      backFn: function() {
        if (IS_APP) {
          myBridge.call('switchTitleBar', {
            isHidden: 0
          })
          myBridge.call('isPullRefreshEnable', {
            enable: 1
          })
          myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
        }
      }
    }

    if (IS_APP) {
      myBridge.call('switchTitleBar', {
        isHidden: 1
      })
      myBridge.call('isPullRefreshEnable', {
        enable: 0
      })
      myBridge.call('setConfig', { isAllowedTitleAnimate: 0 })
    }

    COMMENT.show($config)
  }

  // 回复操作
  window.replayOperation = function(content) {
    $('.loadingDiv').hide()
    $('.loadingDiv').show()
    // $('.loadingDiv').show();
    let e = lastReplayInfo.replayEle
    let _content = encodeURIComponent(linebreakReplace(content))
    // if (UAobj.isiPhone && IS_APP) {
    //     // _content = encodeURIComponent(linebreakReplace(decodeURIComponent(content)));
    //     _content = JSON.parse(content).content;
    //     // console.log('not android', linebreakReplace(decodeURIComponent(content)));
    //     // console.log('not android1', JSON.parse(linebreakReplace(decodeURIComponent(content))).content) console.log('not android', linebreakReplace(decodeURIComponent(content)));
    //     // console.log('not android1', JSON.parse(linebreakReplace(decodeURIComponent(content))).content)
    // } else {
    //     _content = encodeURIComponent(linebreakReplace(content));
    //     // console.log('android', linebreakReplace(content));
    // }
    // _content = encodeURIComponent(linebreakReplace(content));

    // if (IS_APP) {
    //     myBridge.call('dismissEditDialog');
    // }
    if (IS_APP) {
      myBridge.call('switchTitleBar', { isHidden: 0 })
      myBridge.call('isPullRefreshEnable', { enable: 1 })
      myBridge.call('setConfig', { isAllowedTitleAnimate: 1 })
    }
    $http
      .post(
        api.answerReplay,
        {
          answer_id: lastReplayInfo.answerId,
          content: _content,
          reply_user_id: lastReplayInfo.lastReplayId,
          token
        },
        { timeout: 20000, disabledUnLoginInterceptors: true }
      )
      .then(
        res => {
          $('.loadingDiv').hide()
          // $('#diolg').hide()
          let _res = res.data
          let _code = +_res.code
          if (_code === 0) {
            window.localStorage.removeItem('reply_content')
            // app下关闭回复框
            let template = ''
            if (_res.data.reply_user_id !== 0) {
              template = `<div class="main-content">
                    <span class="name" data-user-id=${_res.data.user_id}>${
                _res.data.user_name
              }</span>
                    <span>回复</span>
                    <span class="name" data-user-id=${
                      _res.data.reply_user_id
                    }>${_res.data.reply_user_name}：</span>
                    <span class="content-detail"> ${decodeURIComponent(
                      _res.data.content
                    )}</span>
                    <span class="content-reply">回复</span>
                </div>`
            } else {
              template = `<div class="main-content">
                    <span class="name" data-user-id=${_res.data.user_id}>${
                _res.data.user_name
              }：</span>
                    <span class="content-detail"> ${decodeURIComponent(
                      _res.data.content
                    )}</span>
                    <span class="content-reply">回复</span>
                </div>`
            }

            e.parent('.input-comment').before(template)
            e.parents('.comment-content')
              .siblings('.ask-btn')
              .children('.ask-btn-comment')
              .children('.number')
              .children('span')
              .text(lastReplayInfo.replayNum + 1)
            window.toast('评论成功')
            window.yxl.stat.send({
              name: '问答-主页「回答内容操作事件合集」点击',
              properties: {
                操作分类: '评论提交'
              }
            })
          } else if (_code === 40002) {
            window.toast(res.data.message)
            window.sessionStorage.setItem('answer_area_content', content)
          } else if (_code === 40003) {
            window.toast(
              '您的账号违规已禁止发布问答，申诉请联系答疑馆-喵酱（微信号：dolphin_xinli001）~喵~'
            )
          } else {
            window.sessionStorage.setItem('answer_area_content', content)
          }
          e.attr('replayId', null)
          e.attr('placeholder', '回复评论')
        },
        err => {
          $('.loadingDiv').hide()
          // window.toast('评论失败，您输入的内容还会保留，请重新编辑提交');
          window.sessionStorage.setItem('answer_area_content', content)
        }
      )
  }

  // 分享操作
  window.shareForApp = function() {
    let shareConfig = {
      name: '问答-主页「回答内容操作事件合集」点击',
      properties: {
        操作分类: '分享'
      }
    }
    myBridge.call('stat', shareConfig)
  }

  // app登录处理
  window.loginOperation = function(tokenObj) {
    let result = JSON.parse(tokenObj)
    if (typeof result.token === 'undefined' || result.token === '') {
      refreshUrl()
      let rewardOBJ = new Reward({
        el: '.award-img',
        token: ''
      })
    } else {
      appToken = result.token
      refreshUrl()
      userNotice(appToken)
      initLevelPopup(appToken)
      token = result.token
      loginJudment(true)
    }
  }

  function refreshUrl() {
    if (UAobj.isiPhone && IS_APP) {
      const URLParams = new URLSearchParams(window.location.search)
      let urlToken = URLParams.get('token') || ''
      if (urlToken !== appToken) {
        URLParams.set('token', appToken)
        let _search = URLParams.toString()
        window.location.href = api.host + '/qa?' + _search
      }
    }
  }

  // APP功能登录性验证
  window.adjustLoginForApp = function(tokenObj) {
    let result = JSON.parse(tokenObj)
    if (typeof result.token === 'undefined' || result.token === '') {
      window.location.href = api.login
      appToken = ''
      token = ''
    } else {
      appToken = result.token
      token = result.token
    }
    getTokenLock = false
  }

  function loginJudment(isFirstLoading) {
    if (!IS_APP) {
      // 是否是刚进来加载，不是则表示是功能判断登录
      if (isFirstLoading) {
        $http
          .get(api.isLogin)
          .then(res => {
            if (
              res.data.data.user &&
              typeof res.data.data.user.length === 'undefined'
            ) {
              token = res.data.data.user.token
              let rewardOBJ = new Reward({
                el: '.award-img',
                token: token,
                userId: res.data.data.user.id
              })
              if (res.data.data.user.qaRole !== null) {
                userNotice()
                initLevelPopup()
              } else {
                renderRoleChoose()
              }

              new clockCardToast(token)
            } else {
              let rewardOBJ = new Reward({
                el: '.award-img',
                token: ''
              })

              setTimeout(() => {
                window.toast('检测到暂未登录,即将跳转到登录页面~')
                window.location.href = api.login
              }, 60000)
            }
          })
          .catch(err => {
            // window.toast(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: api.isLogin
            })
          })
      } else {
        if (token === '') {
          window.toast('检测到暂未登录,即将跳转到登录页面~')
          window.location.href = api.login
        }
      }
    } else {
      if (isFirstLoading) {
        $http
          .get(api.isLogin + '?token=' + appToken)
          .then(res => {
            if (
              res.data.data.user &&
              typeof res.data.data.user.length === 'undefined'
            ) {
              // token = res.data.data.token;
              if (res.data.data.user.qaRole !== null) {
                // 打赏初始化
                let rewardOBJ = new Reward({
                  el: '.award-img',
                  token: appToken,
                  userId: res.data.data.user.id
                })
              } else {
                renderRoleChoose()
              }
            }
          })
          .catch(err => {
            // window.toast(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: api.isLogin + '?token=' + appToken
            })
          })

        new clockCardToast(appToken)
      } else {
        // if (appToken === "") {
        //   window.toast("检测到暂未登录,即将跳转到登录页面~");
        //   window.location.href = api.login;
        // }
        if (!getTokenLock) {
          getTokenLock = true
          myBridge.call('getToken', { callbackName: 'adjustLoginForApp' })
        }
      }
    }
  }
  if (!IS_APP) {
    loginJudment(true)
  }

  function renderRoleChoose() {
    $('.navBar').before(`
      <div class="chooseRole">
        <div class="wrap">
          <p>选择适合我的蘑菇角色</p>
          <i class="yxlicon icon-iconfonti"></i>
        </div>
      </div>
    `)

    $('.chooseRole').on('click', function() {
      if (IS_APP) {
        myBridge.call('openWebView', {
          url: window.baseInfo.qa_user_guide_url,
          isCurrentPageOpen: 1
        })
      } else {
        window.location.href = window.baseInfo.qa_user_guide_url
      }
    })
  }

  function latestQuestion() {
    $http
      .get(api.latestQuestion)
      .then(res => {
        if (res.data.code === 0) {
          lastQuesId = res.data.data.id
          if (window.localStorage['newQuesId']) {
            if (window.localStorage['newQuesId'] !== res.data.data.id) {
              if (
                !$('.rank-essence')
                  .children('div')
                  .hasClass('active-section')
              ) {
                $('.new-ques').show()
                $('.newques ul').html('')
                $('.all_data').attr('page', '1')
                $('.rank-essence').attr('page', '1')
              }
              // window.localStorage['newQuesId'] = res.data.data.id;
            } else {
              // console.log('3');
              // $('.new-ques').hide();
            }
          } else {
            $('.new-ques').show()
            // window.localStorage['newQuesId'] = res.data.data.id;
          }
          // console.log(res.data.data.id);

          // 神策埋点
          track.trackEvent('qa_homepage_paging', {})
        }
      })
      .catch(err => {
        // window.toast(err)
        monitor.stat({
          level: 'error',
          error: 'api-data',
          msg: err,
          api: api.latestQuestion
        })
      })
  }

  // 顶部消息通知
  function userNotice(token) {
    // 发请求
    $http
      .get(api.getUserNotice, {
        params: {
          token
        }
      })
      .then(res => {
        if (res.data.code === 0) {
          let data = res.data.data,
            invite_num = +data.invite_num,
            notice_num = +data.notices - invite_num
          if (notice_num < 0) {
            notice_num = 0
          }
          if (invite_num || notice_num) {
            hasUserNotice = true
            let strTemplate = '',
              $template = $('<div class="newTips-container"></div>')
            if (invite_num) {
              if (invite_num > 99) {
                invite_num = '99+'
              }
              strTemplate += `<span class="newTips-invite"><span>${invite_num}</span>个邀答&nbsp;</span>`
            }
            if (notice_num) {
              if (notice_num > 99) {
                notice_num = '99+'
              }
              strTemplate += `<span class="newTips-total"><span>${notice_num}</span>条消息</span>`
            }
            $template.append(strTemplate)
            $('.newTips').append($template)
            // 绑事件
            $template.on('click', function() {
              loginJudment(false)

              window.yxl.stat.send({
                name: '问答首页',
                properties: {
                  对象: '消息提醒',
                  行为: '点击'
                }
              })

              hasUserNotice = false
              $('.newTips').hide()
              let url = api.clearInviteNum
              if (token) {
                url += `?token=${token}`
              }
              $http
                .post(url)
                .then(res => {
                  console.log(res.data)
                })
                .catch(err => {
                  monitor.stat({
                    level: 'error',
                    error: 'api-data',
                    msg: err,
                    api: url
                  })
                })
              let _version = GetQueryString('_version')
              if (IS_APP) {
                if (versionfunegt(_version, '5.9.9')) {
                  window.location.href = 'yixinli://open_message_center?type=0'
                } else {
                  myBridge.call('openWebView', {
                    url: PROTOCOL + api.userMessage,
                    isCurrentPageOpen: 0
                  })
                }
              } else {
                window.open(api.userMessage)
              }
            })
          }
        }
      })
      .catch(err => {
        monitor.stat({
          level: 'error',
          error: 'api-data',
          msg: err,
          api: api.getUserNotice
        })
      })
  }

  // 初始化等级弹窗
  function initLevelPopup(token) {
    let url = token ? `${api.levelPopup}?token=${token}` : api.levelPopup
    $http
      .get(url)
      .then(res => res.data)
      .then(res => {
        if (+res.code === 0) {
          if (res.data.name) {
            let LevelPopup = new levelPopup()
            LevelPopup.show(res.data)
          }
        } else {
          window.toast(res.message)
        }
      })
  }

  let wrapList = [
    'homeWrap',
    'psychicCoachWrap',
    'hotsWrap',
    'topicsWrap',
    'branchsWrap',
    'specialsWrap'
  ]
  $('.navBar span').on('click', function() {
    let $this = $(this)
    if ($this.hasClass('active')) return
    $this
      .siblings()
      .removeClass('active')
      .end()
      .addClass('active')
    let currIdx = $this.index()
    if (currIdx) {
      isQaHomeTab = false
      $('.container').addClass('flex-container')
      if (IS_APP) {
        if (UAobj.isAndroid) {
          $('.container').css('padding-bottom', `1.73333rem`)
          $('.loading-more').css('bottom', `1.73333rem`)
        }
        myBridge.call('isPullRefreshEnable', {
          enable: 0
        })
        myBridge.call('setConfig', {
          isAllowedTitleAnimate: 0
        })
        myBridge.call('switchTitleBar', {
          isHidden: 0
        })
      }
    } else {
      isQaHomeTab = true
      $('.container')
        .removeClass('flex-container')
        .css('padding-bottom', `0px`)
      $('.loading-more').css('bottom', `0px`)
      if (IS_APP) {
        myBridge.call('isPullRefreshEnable', {
          enable: 1
        })
        myBridge.call('setConfig', {
          isAllowedTitleAnimate: 1
        })
      }
    }
    if ([1, 3].includes(currIdx)) {
      $('.navBar').css('padding-bottom', '.48rem')
    } else {
      $('.navBar').css('padding-bottom', '0')
    }
    if (![3].includes(currIdx)) {
      $('.rankContainer').hide()
    }
    wrapList.forEach((wrap, idx) => {
      if (currIdx === idx) {
        if ([0, 1].includes(currIdx)) {
          $(`.${wrap}`).show()
        } else {
          $(`.${wrap}`)
            .show()
            .addClass('displayFlex')
        }
      } else {
        $(`.${wrap}`)
          .removeClass('displayFlex')
          .hide()
      }
    })

    window.yxl.stat.send({
      name: '问答-交互行为',
      properties: {
        页面: '首页',
        行为: '点击',
        对象: '顶部tab',
        文字: $this.text()
      }
    })

    // 神策埋点
    track.trackEvent('qa_homepage_toplist_tap', {
      button_name: $this.text()
    })

    if (!$this.attr('hasData')) {
      $this.attr('hasData', true)
      switch (currIdx) {
        case 1:
          // 心探
          new PsychicCoachList()
          break
        case 2:
          // 热搜
          new HostSearchList()
          break
        case 3:
          // 故事集
          new TopicList(token)
          break
        case 4:
          // 分馆
          new BranchList(token)
          break
        case 5:
          new SpecialList()
          break
        default:
          break
      }
    }

    if (currIdx === 5 && $this.hasClass('redSpot')) {
      $this.removeClass('redSpot')
      let date = new Date()
      localStorage.specialsRedSpot = JSON.stringify({
        lastTime: [
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        ].join('')
      })
    }
  })

  qa = (function() {
    let type = 'recommend'
    let page = 1
    let initEle = $('.rank-popular') // 初始化选中
    let loading = false // 是否加载数据
    let newques_tab_num = 0
    let rank_tab_num = 0
    let reward_tab_num = 0
    // let token = 'b291fc2364e42b5613228d81faa43456'; //本地测试用token

    let wantType = GetQueryString('want_need') // 弹窗类型
    let storage = window.localStorage // localstorage

    // 推荐操作
    let recommendOperationQa = function() {
      $(document).delegate('.input-comment input', 'click', function(event) {
        loginJudment(false)
        if (IS_APP && appToken === '') {
          return
        }

        if (!IS_APP && token === '') {
          return
        }
        let tempELe = $(this)
          .parents('.comment-content')
          .siblings('.ask-btn')
        // let answerId = tempELe.children('.ask-btn-use').attr('data-answer-id');

        let number = tempELe
          .children('.ask-btn-comment')
          .children('.number')
          .children('span')
        // let replayNum = parseInt(number.text())

        lastReplayInfo.lastReplayId = $(this).attr('replayId') || null
        lastReplayInfo.replayEle = $(this)
        lastReplayInfo.answerId = tempELe
          .children('.ask-btn-use')
          .attr('data-answer-id')
        lastReplayInfo.replayNum = parseInt(number.text())
        reply()

        // window.toast('不能回复自己！');
        // let e = lastReplayInfo.replayEle
        // e.attr('replayId', null);
        // e.attr('placeholder', '回复评论');
        // reply()

        // let content = $(this).val();
        // if (content === '') {
        //     window.toast('请输入评论内容');
        //     return;
        // }
        // $(this).val('');
        // $http.post(api.answerReplay, qs.stringify({
        //         answer_id: answerId,
        //         content: content,
        //         reply_user_id: replayId,
        //         // token: token
        //     }), {
        //         disabledUnLoginInterceptors: true,
        //     })
        //     .then(res => {
        //         if (res.data.code === 40002) {
        //             window.toast(res.data.message);
        //             $(this).attr('replayId', null);
        //             $(this).attr('placeholder', '回复评论');
        //             return;
        //         }
        //         if (res.data.code === 40001) {
        //             window.toast('未登录,即将跳转登录');
        //             window.location.href = api.login;
        //         }
        //         if (res.data.code === 0) {
        //             let template = '';
        //             if (res.data.data.reply_user_id !== 0) {
        //                 template = `<div class="main-content">
        //         <span class="name" data-user-id=${res.data.data.user_id}>${res.data.data.user_name}</span>
        //         <span>回复</span>
        //         <span class="name" data-user-id=${res.data.data.reply_user_id}>${res.data.data.reply_user_name}：</span>
        //         <span class="content-detail">${res.data.data.content}</span>
        //     </div>`;
        //             } else {
        //                 template = `<div class="main-content">
        //         <span class="name" data-user-id=${res.data.data.user_id}>${res.data.data.user_name}: </span>
        //         <span class="content-detail">${res.data.data.content}</span>
        //     </div>`;
        //             }

        //             $(this).parent('.input-comment').before(template);
        //             window.toast('回复成功');
        //         }

        //         $(this).attr('replayId', null);
        //         $(this).attr('placeholder', '回复评论');
        //         number.text(replayNum + 1)
        //         console.log(res);
        //     })
        //     .catch(err => window.toast(err));
      })

      $(document).delegate('.name, .content-reply', 'click', function() {
        loginJudment(false)
        let replayId, name
        if (this.className === 'content-reply') {
          let $replay = $(this)
            .parents('.main-content')
            .children(':first')
          replayId = $replay.attr('data-user-id')
          name = $replay.text()
        } else {
          replayId = $(this).attr('data-user-id')
          name = $(this).text()
        }

        // console.log(name);
        if (window.baseInfo.user_id === replayId) {
          window.toast('不能回复自己！')
          return
        }
        $(this)
          .parents('.main-content')
          .siblings('.input-comment')
          .children('input')
          .attr('placeholder', '@' + name)
        $(this)
          .parents('.main-content')
          .siblings('.input-comment')
          .children('input')
          .attr('replayId', replayId)
      })

      // 还能邀答
      $(document).delegate('.ques-btn-invite', 'click', function(e) {
        e.preventDefault()

        window.yxl.stat.send({
          name: '题主说-邀答',
          properties: {
            行为: '点击'
          }
        })

        let num = $(this)
          .find('.time')
          .text()
        if (+num === 0) {
          window.toast('分享问题给好友，每天可以增加邀答1次。')
          return
        }

        loginJudment(false)

        let href =
          PROTOCOL +
          api.inviteList +
          '?ask_id=' +
          $(this).attr('data-question_id')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
      })

      $(document).delegate('.share-rank', 'click', function(e) {
        window.yxl.stat.send({
          name: '实时榜单-分享',
          properties: {
            行为: '点击'
          }
        })
      })

      $(document).delegate('.ask-btn-comment', 'click', function(e) {
        let answerId = $(this).attr('data-answer-id')
        if (
          $(this)
            .parent('.ask-btn')
            .siblings('.comment-content')
            .css('display') === 'none'
        ) {
          $('.loadingDiv').show()
          $(this)
            .parent('.ask-btn')
            .siblings('.comment-content')
            .children('.main-content')
            .remove()
          getQaReply(answerId, $(this))
        }
        $(this)
          .parent('.ask-btn')
          .siblings('.comment-content')
          .toggle()
        $(this)
          .parent('.ask-btn')
          .siblings('.footer')
          .toggle()
        // $(this).parent('.ask-btn').siblings('.comment-content').toggle();
        // $(this).parent('.ask-btn').siblings('.footer').toggle();
      })

      // 更多内容的委托事件
      $(document).delegate(
        '.author-honor, .ques-btn-feel, .sameFeel_div',
        'click',
        function(event) {
          if (
            $(this)
              .parents('.recommend-content')
              .hasClass('paidQa')
          )
            return
          loginJudment(false)
          if (isFeel) {
            return
          }

          if (IS_APP && appToken === '') {
            return
          }

          if (!IS_APP && token === '') {
            return
          }

          // console.log($(this).attr('data-question_id'));
          let id = $(this).attr('data-question_id')
          let tab = $(this).attr('data-tab')

          let isRewardUl = $(this).hasClass('sameFeel_div')

          isFeel = true

          $http
            .get(api.sameFeel + '?question_id=' + id)
            .then(res => {
              // console.log(res)
              let ele = $(this)
                .children('p')
                .children('span')
              let feelNumber = ele.text()
              let isHasFeel
              if (tab) {
                isHasFeel = $(this)
                  .children('p')
                  .hasClass('has-feel')
              } else if (isRewardUl) {
                isHasFeel = $(this).hasClass('has-feel')
              } else {
                isHasFeel = ele.hasClass('has-feel')
              }
              if (isHasFeel) {
                if (!feelNumber.includes('w') && !feelNumber.includes('k')) {
                  ele.text(parseInt(feelNumber) - 1)
                }
                if (tab) {
                  $(this)
                    .children('p')
                    .removeClass('has-feel')
                } else if (isRewardUl) {
                  $(this).removeClass('has-feel')
                } else {
                  ele.removeClass('has-feel')
                }
              } else {
                if (!feelNumber.includes('w') && !feelNumber.includes('k')) {
                  ele.text(parseInt(feelNumber) + 1)
                }
                if (tab) {
                  $(this)
                    .children('p')
                    .addClass('has-feel')
                } else if (isRewardUl) {
                  $(this).addClass('has-feel')
                } else {
                  ele.addClass('has-feel')
                }
              }
              let isSameFeeling = res.data.data.is_same_feeling === 1
              if (isSameFeeling) {
                window.yxl.stat.send({
                  name: '问答首页',
                  properties: {
                    对象: '有同感',
                    行为: '点击',
                    类型: isRewardUl ? '悬赏专区' : tab ? '题主说' : '答主说'
                  }
                })
              }

              if (!isRewardUl) {
                if (isSameFeeling) {
                  if (this.similarProblem) {
                    $(this)
                      .parent()
                      .siblings('.similarProblem')
                      .show()
                  } else {
                    this.similarProblem = new similarProblem(id)
                    this.similarProblem.render().then(template => {
                      $(this).hasClass('author-honor')
                        ? $(this)
                            .parent()
                            .siblings('.author')
                            .before(template)
                        : $(this)
                            .parent()
                            .after(template)
                    })
                  }
                } else {
                  $(this)
                    .parent()
                    .siblings('.similarProblem')
                    .hide()
                }
              }

              isFeel = false
              // window.toast(res.data.message)
            })
            .catch(err => {
              // window.toast(err)
              isFeel = false
              monitor.stat({
                level: 'error',
                error: 'api-data',
                msg: err,
                api: api.sameFeel + '?question_id=' + id
              })
            })
        }
      )

      // 更多内容的委托事件
      $(document).delegate('.switch', 'click', function(event) {
        event.preventDefault()

        if ($(this).attr('data-tab') === 'ques') {
          window.yxl.stat.send({
            name: '问答首页',
            properties: {
              对象: '问题描述全文',
              行为: '点击'
            }
          })
        }

        $(this)
          .siblings('.ask-detail')
          .removeClass('hide-content')
        $(this).css('display', 'none')
        $(this)
          .siblings('.arrow')
          .css('display', 'block')
      })

      // 收起
      $(document).delegate('.arrow', 'click', function(event) {
        event.preventDefault()
        $(this)
          .siblings('.ask-detail')
          .addClass('hide-content')
        $(this).css('display', 'none')
        $(this)
          .siblings('.switch')
          .css('display', 'block')
      })

      // 抖动效果
      let vibrateInterval
      let startVibrate = function(level) {
        navigator.vibrate(level)
      }

      // $(document).delegate('.award-img', 'click', function(e) {
      //     e.preventDefault()
      //     if (IS_APP) {
      //         if (!appToken) {
      //             window.toast('未登录,即将跳转登录');
      //             window.location.href = api.login;
      //         }
      //     } else {
      //         if (!token) {
      //             window.toast('未登录,即将跳转登录');
      //             window.location.href = api.login;
      //         }
      //     }
      // })

      // 点击有用和无用
      $(document).delegate('.ask-btn-use', 'click', function() {
        if (isLike) {
          return
        }
        // console.log($(this).attr('data-answer-id'));
        let id = $(this).attr('data-answer-id')
        isLike = true
        $http
          .get(api.likeQuestion + '?answer_id=' + id, {
            disabledUnLoginInterceptors: true
          })
          .then(res => {
            if (res.data.code === 40001) {
              window.toast('未登录,即将跳转登录')
              window.location.href = api.login
              isLike = false
            }
            if (res.data.code === 40002) {
              window.toast(res.data.message)
              isLike = false
              return
            }
            if (res.data.code === -1) {
              window.toast(res.data.message)
              isLike = false
              return
            }
            if (res.data.code === 0) {
              let number = parseInt(
                $(this)
                  .children('span')
                  .children('.detail-number')
                  .text()
              )
              // let amitImg = $(this).children('i').eq(1);
              // if (amitImg.attr('attr-id') === 'no-use' && amitImg.css('display') === 'block') {
              //     $(this).children('span').children('.detail-number').text(number + 1);
              // } else {
              //     $(this).children('span').children('.detail-number').text(number - 1);
              // }
              $(this)
                .children('i')
                .toggle()
              // window.toast(res.data.message);
              if (res.data.data.is_zan === '1') {
                $(this)
                  .children('span')
                  .addClass('isUseful')
                  .children('.detail-number')
                  .text(number + 1)
                if (IS_APP) {
                  myBridge.call('shake', { milliseconds: 200 })
                } else {
                  if ('vibrate' in navigator) {
                    startVibrate(200)
                  }
                }

                window.yxl.stat.send({
                  name: '问答-主页「回答内容操作事件合集」点击',
                  properties: {
                    操作分类: '点赞'
                  }
                })
              } else {
                $(this)
                  .children('span')
                  .removeClass('isUseful')
                  .children('.detail-number')
                  .text(number - 1)
              }
              isLike = false
            }
          })
          .catch(err => {
            // window.toast(err)
            isLike = false
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: api.likeQuestion + '?answer_id=' + id,
              apiParams: JSON.stringify({
                disabledUnLoginInterceptors: true
              })
            })
          })
      })

      // 点击推荐关注
      $(document).delegate(
        '.is-attentioned, .rank-attention',
        'click',
        function() {
          loginJudment(false)
          let id = $(this).attr('data-user-id')
          let tab = $(this).attr('data-tab')
          let isTeacher = tab
            ? $(this).attr('data-teacher')
            : $(this)
                .parents('.attention-list')
                .attr('data-teacher')
          let url
          if (IS_APP && token) {
            url = api.followAttention + '?user_id=' + id + '&token=' + token
          } else {
            url = api.followAttention + '?user_id=' + id
          }
          $http
            .get(url, {
              disabledUnLoginInterceptors: true
            })
            // $http.get(api.followAttention + '?user_id=' + id + '&token=' + token,{
            //     disabledUnLoginInterceptors: true
            // })
            .then(res => {
              // 全局的拦截器已经错了，这边的注释掉就行了
              // if (res.data.code === 40001) {
              //   window.toast('未登录,即将跳转登录')
              //   window.location.href = api.login
              // }
              if (res.data.code === 40002) {
                window.toast(res.data.message)
                return
              }
              if (res.data.code === 1) {
                window.toast(res.data.message)
                return
              }
              if (res.data.code === 0) {
                window.toast(res.data.message)
                $(this)
                  .children('p')
                  .toggle()
                if (res.data.data.is_follow === 1) {
                  window.yxl.stat.send({
                    name: '问答-交互行为',
                    properties: {
                      页面: tab === 'rank' ? '首页榜单' : '首页',
                      行为: '点击',
                      对象: '关注',
                      咨询师: isTeacher,
                      id
                    }
                  })
                }
                // 积分
                if (IS_APP) {
                  const saveTask = funFactory(
                    `${getEnvHost(
                      '//yiapi.xinli001.com'
                    )}/v6/yi/integral/save-task.json`,
                    'post'
                  )
                  saveTask({
                    task_type: '3',
                    task_action: 'follow_user',
                    business: 'follow',
                    business_id: id,
                    token: token
                  }).then(res => {
                    const { message, code } = res
                    if (code === 0 && message) {
                      myBridge.call('showMessage', {
                        content: message,
                        type: 'integral'
                      })
                    }
                  })
                }
              }
            })
            .catch(err => {
              // window.toast(err)
              console.error(err)
              monitor.stat({
                level: 'error',
                error: 'api-data',
                msg: err,
                api: url,
                apiParams: JSON.stringify({
                  disabledUnLoginInterceptors: true
                })
              })
            })
        }
      )

      $('.rank_ul').on('click', '.rank-avatar, .rank-info-name', function(e) {
        let href =
          $(this).attr('href') ||
          $(this)
            .children('a')
            .attr('href')
        avatarClick(
          e,
          href,
          $(this)
            .parents('.rank-item')
            .attr('data-user-id'),
          $(this)
            .parents('.rank-item')
            .attr('data-teacher'),
          '首页榜单'
        )
      })

      function avatarClick(event, href, userId, isTeacher, source) {
        event.preventDefault()

        if (href === 'javascript:;' || !href) return

        href = addQueryToUrl(href, {
          _source_page_: encodeURIComponent('人生答疑馆')
        })

        window.yxl.stat.send({
          name: '问答-交互行为',
          properties: {
            页面: source,
            行为: '点击',
            对象: '用户头像',
            咨询师: isTeacher,
            id: userId
          }
        })

        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
        }
      }

      $(document).delegate('.author-name, .attention-img', 'click', function(
        e
      ) {
        let href = '',
          userId = '',
          isTeacher = ''
        if ($(this).hasClass('attention-img')) {
          href = $(this)
            .children('a')
            .attr('href')
          userId = $(this)
            .parents('.attention-list')
            .attr('data-user-id')
          isTeacher = $(this)
            .parents('.attention-list')
            .attr('data-teacher')
        } else {
          let $0 = $(this)
          href = $0.attr('href')
          userId = $0.attr('data-user-id')
          isTeacher = $0.attr('data-teacher')
        }

        avatarClick(e, href, userId, isTeacher, '首页')
      })

      // 排行榜 向ta提问
      $(document).delegate('.ques', 'click', function() {
        let url = PROTOCOL + api.postQuestion
        let id = $(this).attr('data-user_id')
        let name = $(this).attr('data-nickname')

        let tabIndex = $(this)
          .parents('.rank_ul')
          .siblings()
          .children('.active')
          .index()

        $http
          .get(api.getInviteNum)
          .then(res => res.data)
          .then(res => {
            if (+res.code === 0) {
              if (parseInt(res.data.invite_num) <= 0) {
                window.toast('你的问答邀请次数已用完,无法继续邀请~')
              } else {
                let storage = window.localStorage
                storage['invite_user'] = id
                window.yxl.stat.send({
                  name: '实时榜单-向ta提问',
                  properties: {
                    行为: '点击',
                    类型: tabIndex === 1 ? '精华榜' : '贡献榜',
                    用户名: name
                  }
                })
                if (IS_APP) {
                  myBridge.call('openWebView', {
                    url: url,
                    isCurrentPageOpen: 0
                  })
                } else {
                  window.location.href = url
                }
              }
            }
          })
          .catch(err => window.toast(err))
      })
    }

    // 是否显示全文
    function showSwithFn() {
      let curList
      if (type === 'recommend') {
        //  答主说
        curList = $('.recommend .recommend-content .ask-detail')
      } else if (type === 'newques') {
        //  题主说
        curList = $('.newques .recommend-content .ask-detail')
      }
      curList &&
        curList.each(function(index, e) {
          // console.log($(e).height())
          // console.log($(e)[0].scrollHeight)
          if ($(e).height() < $(e)[0].scrollHeight) {
            $(e)
              .siblings('.switch')
              .css('display', 'block')
          } else {
            $(e)
              .siblings('.switch')
              .css('display', 'none')
          }
        })
    }

    $(document).delegate('.rewardlist .follow', 'click', function() {
      loginJudment(false)
      if (isAttention) {
        return
      }
      if (IS_APP && appToken === '') {
        return
      }

      if (!IS_APP && token === '') {
        return
      }
      isAttention = true

      console.log($(this).attr('data-question_id'))
      let id = $(this).attr('data-question_id')
      $http
        .get(api.storeQuestion + '?question_id=' + id)
        .then(res => {
          if (
            $(this)
              .children('i')
              .hasClass('icon-unstar')
          ) {
            $(this)
              .children('i')
              .removeClass('icon-unstar')
            $(this)
              .children('i')
              .addClass('icon-instar')
          } else {
            $(this)
              .children('i')
              .addClass('icon-unstar')
            $(this)
              .children('i')
              .removeClass('icon-instar')
          }
          if (res.data.data.is_store == 1) {
            $(this)
              .children('label')
              .text('已关注')
            window.yxl.stat.send({
              name: '问答-悬赏区「问题内容操作合集」点击',
              properties: {
                操作分类: '关注'
              }
            })
            if (IS_APP) {
              const $dataEl = $(this).siblings('.share')
              const qid = $(this).attr('data-question_id')
              const title = $dataEl.attr('data-title')
              // const cover = $dataEl.attr('data-cover')

              myBridge.call('showRecommendToDynamicDialog', {
                content: '将这条问答推荐到动态吧',
                buttonText: '去推荐',
                object_id: qid,
                object_type: 10,
                object_title: title,
                object_cover:
                  'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100'
              })
            }
          } else {
            $(this)
              .children('label')
              .text('关注')
          }
          isAttention = false
        })
        .catch(err => {
          isAttention = false
          monitor.stat({
            level: 'error',
            error: 'api-data',
            msg: err,
            api: api.storeQuestion + '?question_id=' + id
          })
        })
    })

    let scroll = throttle(function() {
      if (!isQaHomeTab) return

      let h = document.documentElement.offsetHeight
      let rect = document.documentElement.getBoundingClientRect()

      let min = 60

      if (
        rect.top <= 0 &&
        h - (Math.abs(rect.top) + window.innerHeight) <= min
      ) {
        $('.active-section')
          .parent('.rank')
          .trigger('click')
      }
    }, 1000)

    // 对评论进行构造，然后返回
    let replyContent = function(data, ele) {
      let template = ''
      for (let i = 0; i < data.length; i++) {
        let hasReplyUser = true
        if (typeof data[i].replyuser.id === 'undefined') {
          hasReplyUser = false
        }
        if (hasReplyUser) {
          let templateDetail = `<div class="main-content">
        <span class="name" data-user-id=${data[i].user.id}>${data[i].user.nickname}</span>
        <span>回复</span>
        <span class="name" data-user-id="${data[i].replyuser.id}">${data[i].replyuser.nickname}：</span>
        <span class="content-detail"> ${data[i].content}</span>
        <span class="content-reply">回复</span>
        </div>`
          template = template + templateDetail
        } else {
          let templateDetail = `<div class="main-content">
        <span class="name" data-user-id="${data[i].user.id}">${data[i].user.nickname}：</span>
        <span class="content-detail"> ${data[i].content}</span>
        <span class="content-reply">回复</span>
        </div>`
          template = template + templateDetail
        }
      }
      ele
        .parent('.ask-btn')
        .siblings('.comment-content')
        .children('.main-content')
        .remove()
      ele
        .parent('.ask-btn')
        .siblings('.comment-content')
        .children('.input-comment')
        .before(template)
      $('.loadingDiv').hide()
    }

    // 获取某个回答的评论
    let getQaReplying = false
    let getQaReply = function(id, ele) {
      if (getQaReplying) {
        return
      }
      getQaReplying = true
      let template = ''
      $http
        .get(api.getQaReply + '?answer_id=' + id + '&page=1&size=100')
        // $http.get(api.getQaData + '?tag_name=' + tag_name + '&token=' + token + '&page=' + page)
        .then(res => {
          getQaReplying = false
          if (res.data.code === 0) {
            let replyData = res.data.data
            if (replyData.length) {
              replyContent(replyData, ele)
            } else {
              $('.loadingDiv').hide()
            }
          } else {
            $('.loadingDiv').hide()
          }
        })
        .catch(err => {
          getQaReplying = false
          // window.toast(err)
          $('.loadingDiv').hide()

          monitor.stat({
            level: 'error',
            error: 'api-data',
            msg: err,
            api: api.getQaReply + '?answer_id=' + id + '&page=1&size=100'
          })
        })
    }

    // 广告流数据模板
    let adTemplate = function(data) {
      return `<div attr-href=${data.url} class="adver-area"><img src=${data.image} alt=""></div>`
    }

    // 初始化加载数据和共通操作
    qa.init = function() {
      // 推荐操作
      recommendOperationQa()

      latestQuestion()

      $('.rank-popular')
        .children('.title')
        .css('font-weight', 'bold')

      $(document).delegate('.adver-area', 'click', function() {
        let href = $(this).attr('attr-href')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
        }
      })

      // 获取广告
      let params = {
        name: 'qa-home-flow15', // 广告位名称 例如: index_banner
        size: '100', // 广告数量，默认5
        _version: UAobj.yixinliAPPVersion || '5.3.8', // App版本号
        // channel: '', // App渠道
        _platform: 'ios' // 平台，ios或android 默认值: ios
      }
      window.URLSearchParams = URLSearchParams
      const URLParams = new URLSearchParams(window.location.search)
      let _token = URLParams.get('token')
      if (_token) {
        params.token = _token
      }
      let platFormSign = getRequestSign(params)
      let newParams = Object.assign(platFormSign.params, {
        sign: platFormSign.sign
      })
      $http
        .get(api.getADList, {
          params: newParams
        })
        // $http.get(api.getQaData + '?tag_name=' + tag_name + '&token=' + token + '&page=' + page)
        .then(res => {
          if (res.data.code === 0) {
            adList = res.data.data
          }
        })
        .catch(err => {
          // window.toast(err)
          console.error(err)
          monitor.stat({
            level: 'error',
            error: 'api-data',
            msg: err,
            api: api.getADList,
            apiParams: JSON.stringify(newParams)
          })
        })

      // 微信分享
      if (window.$platform.isWechat) {
        let currentUrl = document.location.href
        let getWxConfig = api.getWXShareConfig
        let shareInfo = window.baseInfo.wx_share
        $http
          .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
          .then(res => {
            if (res.data.code == 0) {
              var wxConfig = res.data.data

              function loadScript(url, callback) {
                var script = document.createElement('script')
                script.type = 'text/javascript'
                if (typeof callback !== 'undefined') {
                  if (script.readyState) {
                    script.onreadystatechange = function() {
                      if (
                        script.readyState == 'loaded' ||
                        script.readyState == 'complete'
                      ) {
                        script.onreadystatechange = null
                        callback()
                      }
                    }
                  } else {
                    script.onload = function() {
                      callback()
                    }
                  }
                }
                script.src = url
                document.body.appendChild(script)
              }

              setTimeout(() => {
                loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
                  var _config = {
                    debug: wxConfig.debug,
                    appId: wxConfig.appId,
                    timestamp: wxConfig.timestamp,
                    nonceStr: wxConfig.nonceStr,
                    signature: wxConfig.signature,
                    jsApiList: [
                      'onMenuShareTimeline',
                      'onMenuShareAppMessage',
                      'onMenuShareQQ',
                      'onMenuShareWeibo',
                      'onMenuShareQZone',
                      'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                      'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  }

                  // 微信基本配置信息
                  wx.config(_config)
                  wx.ready(function() {
                    var shareConfig = {
                      title: shareInfo.title,
                      desc: shareInfo.desc,
                      link: shareInfo.url.replace(envHost, safeDomain),
                      imgUrl: shareInfo.image,
                      // title: '壹心理-人生答疑馆',
                      // desc: '心理互助与心理学人交流成长的社区',
                      // link: window.location.href,
                      // imgUrl: 'http://lapp-box5.xinli001.com/images/website-mobile/qa_logo.jpg',
                      success: function(res) {},
                      cancel: function(res) {},
                      fail: function(res) {}
                    }
                    // let tempConfig = window.baseInfo.wx_share_config;
                    // tempConfig.imgUrl = tempConfig.cover;
                    // tempConfig.link = tempConfig.url;
                    // var shareConfig = tempConfig;
                    // 分享到朋友圈
                    wx.onMenuShareTimeline(shareConfig)
                    // 分享给朋友
                    wx.onMenuShareAppMessage(shareConfig)
                    // 分享到QQ
                    wx.onMenuShareQQ(shareConfig)
                    // 分享到腾讯微博
                    wx.onMenuShareWeibo(shareConfig)
                    // 分享到QQ空间
                    wx.onMenuShareQZone(shareConfig)
                    wx.updateAppMessageShareData(shareConfig)
                    wx.updateTimelineShareData(shareConfig)
                  })
                })
              }, 500)
            }
          })
      }

      window.addEventListener('scroll', scroll)

      if ($('.' + wantType).length) {
        $('.' + wantType).show()
        $('.diolg,#diolg').show()
      }

      // 获取关注数目
      setTimeout(() => {
        $http
          .get(api.getQaFocusNotices, {
            disabledUnLoginInterceptors: true
          })
          .then(res => {
            // window.toast(res.data.message);
            if (res.data.code === 0) {
              // if (parseInt(res.data.data.focus_qa_new_answer_num) > 0) {

              // }
              // console.log(res.data.data)
              // console.log(res.data.data.is_show)
              // console.log(res.data.data.focus_qa_new_answer_num)
              if (res.data.data.is_show == 1) {
                $('.attention-number').text(
                  res.data.data.focus_qa_new_answer_num
                )
                $('.attention-number').css('display', 'block')
              }
            }
          })
          .catch(err => {
            // window.toast(err)
            console.error(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api: api.getQaFocusNotices,
              apiParams: JSON.stringify({
                disabledUnLoginInterceptors: true
              })
            })
          })
      }, 10000)
      // $('#diolg').on('click', function() {
      //     $('.share-diolg,#diolg,.diolg').hide();
      // });

      // 3个导航进行固定
      let rankTitleTop = $('.rank-title').offset().top
      let userNoticePreTop = 0
      let userNoticeTimer = null
      $(document).scroll(function() {
        if (!isQaHomeTab) return

        let scrollTop = $(document).scrollTop()
        if (scrollTop > rankTitleTop + 70) {
          $('.rank-title').addClass('add-box-shadow')
          $('.rank-title')
            .parent('.add-fixed')
            .addClass('rank-fixed')
          if (IS_APP) {
            $('.rank-title')
              .parent('.add-fixed')
              .addClass('app-rank-fixed')
          } else {
            $('.nav-header').css('display', 'none')
            $('.container').css('padding-top', 0)
          }
        }
        if (scrollTop < rankTitleTop) {
          $('.rank-title').removeClass('add-box-shadow')
          $('.rank-title')
            .parent('.add-fixed')
            .removeClass('rank-fixed')
          if (IS_APP) {
            $('.rank-title')
              .parent('.add-fixed')
              .removeClass('rank-fixed')
            $('.rank-title').removeClass('add-box-shadow')
            $('.rank-title')
              .parent('.add-fixed')
              .removeClass('app-rank-fixed')
          } else {
            $('.nav-header').css('display', 'block')
            $('.container').css('padding-top', '1.22667rem')
          }
        }

        if (hasUserNotice) {
          if (scrollTop >= userNoticePreTop) {
            $('.newTips').hide()
          } else {
            $('.newTips').show()
          }
          userNoticePreTop = scrollTop
          clearTimeout(userNoticeTimer)
          userNoticeTimer = setTimeout(() => {
            $('.newTips').show()
          }, 3000)
        }
      })

      // diolg显示后禁止事件

      $('#diolg,.diolg,.share-diolg').on('touchmove', e => {
        e.preventDefault()
      })

      // 隐藏
      $(document).delegate('.close', 'click', function() {
        $('#diolg,.diolg').hide()
        window.history.pushState(null, '', window.baseInfo.qa_home_url)
      })

      $(document).delegate(
        '.ask-btn-share, .rewar_ul .share',
        'click',
        function() {
          let isRewardUl = $(this).hasClass('share')
          let title =
            (isRewardUl
              ? $(this).attr('data-title')
              : $(this)
                  .children('span')
                  .attr('data-title')) || '壹心理-人生答疑馆'
          let objectTitle
          if (isRewardUl) {
            objectTitle = $(this)
              .parents('li')
              .find('.list_item_title')
              .text()
          } else if (
            $(this)
              .parents('.recommend-content')
              .find('.title-content .title').length > 0
          ) {
            objectTitle = $(this)
              .parents('.recommend-content')
              .find('.title-content .title')
              .text()
              .trim()
          } else {
            // 新问题列表的title不一样
            objectTitle = $(this)
              .parents('.recommend-content')
              .find('.question-title')
              .text()
              .trim()
          }

          let cover =
            (isRewardUl
              ? $(this).attr('data-cover')
              : $(this)
                  .children('span')
                  .attr('data-cover')) ||
            'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100'
          let content =
            $(this)
              .children('span')
              .attr('data-content') || '心理互助与心理学人交流成长的社区'
          let dataUrl =
            (isRewardUl
              ? $(this).attr('data-url')
              : $(this)
                  .children('span')
                  .attr('data-url')) || window.location.href
          let appUrl = $(this)
            .children('span')
            .attr('data-share-url')
          let userImg = $(this)
            .children('span')
            .attr('data-avatar')
          let userNickName = $(this)
            .children('span')
            .attr('data-nickname')
          let quesDesc = isRewardUl
            ? $(this).attr('data-desc')
            : $(this)
                .children('span')
                .attr('data-desc')
          let isQuestion = $(this).hasClass('question')
          let share_config
          if (UAobj.isAndroid) {
            content = linebreakReplace(Base64.decode(content))
          } else {
            title = encodeURIComponent(linebreakReplace(title))
            quesDesc = encodeURIComponent(linebreakReplace(quesDesc))
            content = encodeURIComponent(
              linebreakReplace(Base64.decode(content))
            )
          }
          // alert(content)
          if (IS_APP) {
            // 一些共同配置
            share_config = {
              title: title,
              desc: quesDesc,
              imgUrl: cover,
              callbackName: 'shareForApp'
            }
            if (isQuestion || isRewardUl) {
              // 新问题tab下，分享问题
              let objectId = isRewardUl
                ? $(this)
                    .siblings('.follow')
                    .attr('data-question_id')
                : $(this)
                    .prev('.ask-btn-attention')
                    .attr('data-question_id')
              Object.assign(share_config, {
                link: dataUrl.replace(envHost, safeDomain),
                // 动态分享的字段
                isShowDynamic: 1,
                object_id: objectId,
                object_type: 10,
                object_title: objectTitle,
                object_cover:
                  'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100'
              })
            } else {
              // 推荐和已关注下，分享回答+卡片
              let objectId = $(this)
                .prev('.ask-btn-use')
                .attr('data-answer-id')
              Object.assign(share_config, {
                link: appUrl.replace(envHost, safeDomain),
                userAvatarUrl: userImg,
                userNickName,
                saveImageType: 'saveQACard',
                isHideSaveImage: 0,
                answerContent: content,
                // 动态分享的字段
                isShowDynamic: 1,
                object_id: objectId,
                object_type: 11,
                object_title: objectTitle,
                object_cover:
                  'https://ossimg.xinli001.com/logo20190327.png?x-oss-process=image/resize,h_100',
                sourcePage: '问答首页',
                itemName: '回答详情链接'
              })
            }
            console.log('shareReport', share_config)

            myBridge.call('shareReport', share_config)
          } else {
            window.yxl.stat.send({
              name: '问答-主页「回答内容操作事件合集」点击',
              properties: {
                操作分类: '分享'
              }
            })
            let href = dataUrl + '?is_share=true'
            window.open(href)
            // window.location.href = dataUrl + '?is_share=true';
          }
        }
      )

      // 弹窗关注
      $(document).delegate('.find_same_kind .learn-btn', 'click', function() {
        loginJudment(false)

        let dataEle = $(this)
          .siblings('.learn-content')
          .children('.author-info')
        let flag = true
        if (dataEle) {
          dataEle.each(function() {
            let id = $(this).attr('data-user_id')
            $http
              .get(api.followAttention + '?user_id=' + id, {
                disabledUnLoginInterceptors: true
              })
              // $http.get(api.followAttention + '?user_id=' + id + '&token=' + token,{
              //     disabledUnLoginInterceptors: true
              // })
              .then(res => {
                if (res.data.code === 40001) {
                  flag = false
                  window.toast('未登录,即将跳转登录')
                  window.location.href = api.login
                }
                if (res.data.code === 40002) {
                  window.toast(res.data.message)
                  flag = false
                  return
                }
                if (res.data.code === 0) {
                  // 积分
                  if (IS_APP) {
                    const saveTask = funFactory(
                      `${getEnvHost(
                        '//yiapi.xinli001.com'
                      )}/v6/yi/integral/save-task.json`,
                      'post'
                    )
                    saveTask({
                      task_type: '3',
                      task_action: 'follow_user',
                      business: 'follow',
                      business_id: id,
                      token: token
                    }).then(res => {
                      const { message, code } = res
                      if (code === 0 && message) {
                        myBridge.call('showMessage', {
                          content: message,
                          type: 'integral'
                        })
                      }
                    })
                  }
                }
              })
              .catch(err => {
                // window.toast(err)
                console.error(err)
                monitor.stat({
                  level: 'error',
                  error: 'api-data',
                  msg: err,
                  api: api.followAttention + '?user_id=' + id,
                  apiParams: JSON.stringify({
                    disabledUnLoginInterceptors: true
                  })
                })
              })
          })
          if (flag) {
            $('.diolg,#diolg').hide()
            // storage["want_need"] = wantType;
            window.yxl.stat.send({
              name: '问答-新用户引导「关注ta们」点击'
            })
            // window.history.pushState(null, '', window.baseInfo.qa_home_url)
            window.toast('关注成功')
            setTimeout(() => {
              delete urlparams.want_need
              window.location.href =
                api.host + '/qa?' + objectToQueryString(urlparams)
            }, 300)
          }
        }
      })

      // 提问按钮和埋点
      $(document).delegate('.publish_qa .diolg-btn', 'click', function(e) {
        e.preventDefault()
        // storage["want_need"] = wantType
        window.yxl.stat.send({
          name: '问答-新用户引导-提问「来一发」点击'
        })
        $('.diolg,#diolg').hide()
        let href = $(this)
          .parent('a')
          .attr('href')
        window.history.pushState(null, '', window.baseInfo.qa_home_url)
        // window.location.href = href
        window.localStorage.removeItem('invite_user')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
      })

      // 探索按钮和埋点
      $(document).delegate('.help_other .diolg-btn', 'click', function(e) {
        e.preventDefault()
        // storage["want_need"] = wantType
        window.yxl.stat.send({
          name: '问答-新用户引导-悬赏题目「来一发」点击'
        })
        $('.diolg,#diolg').hide()
        let href = $(this)
          .parent('a')
          .attr('href')
        window.history.pushState(null, '', window.baseInfo.qa_home_url)
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
        // window.location.href = href
      })

      // 学习心理学按钮和对应埋点
      $(document).delegate('.learn_psychology .diolg-btn', 'click', function(
        e
      ) {
        e.preventDefault()
        // storage["want_need"] = wantType
        window.yxl.stat.send({
          name: '问答-新用户引导-科普题目「去探索」点击'
        })
        $('.diolg,#diolg').hide()
        let href = $(this)
          .parent('a')
          .attr('href')
        window.history.pushState(null, '', window.baseInfo.qa_home_url)
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
        // window.location.href = href
      })

      $(document).delegate('.title-content .title', 'click', function(e) {
        e.preventDefault()
        let href = $(this).attr('href')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
        }
      })

      // 分馆入口
      $(document).delegate('.branch-source, .branch-mark', 'click', function(
        e
      ) {
        e.preventDefault()

        // loginJudment(false)
        // if (!token) return

        let href = $(this)
          .parent('a')
          .attr('href')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
        }
      })

      function isStudy(params) {
        let { href, isAcademic } = params
        if (IS_APP) {
          if (RegExp(/search-question/).test(href)) {
            myBridge.call('openSearchQuestionPage')
          } else if (isAcademic) {
            myBridge.call('openShareWebView', {
              url: href,
              pageTitle: '壹心理学研会报名表',
              title: '壹心理学研会报名表',
              desc:
                '为了促进心理人的交流，将心理学知识辐射到普通大众中,使心理学的春天提前到来,壹心理正招募「壹心理学研会」成员',
              link: href,
              imgUrl:
                'http://xinli001.mikecrm.com//images/form/wechat_default.jpg'
            })
          } else {
            myBridge.call('openWebView', {
              url: href,
              isCurrentPageOpen: 0
            })
          }
        } else {
          // window.location.href = href;
          window.open(href)
        }
      }

      // 导航栏埋点
      $(document).delegate('.img-content', 'click', function(e) {
        e.preventDefault()
        let $el = $(this),
          href = $el.parent('a').attr('href'),
          isAcademic = false
        window.yxl.stat.send({
          name: '问答-交互行为',
          properties: {
            页面: '首页',
            行为: '点击',
            对象: `顶部导航栏「${$el.attr('keydesc')}」`,
            地址: href
          }
        })
        // 学研会 搜索
        isStudy({
          href,
          isAcademic
        })
      })

      // 我的问答埋点
      $('.my-ques').on('click', function(e) {
        e.preventDefault()
        let href = $(this)
          .parent('a')
          .attr('href')
        window.yxl.stat.send({
          name: '问答-主页「我的问答」点击'
        })
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
          // window.location.href = href;
        }
        // window.location.href = href
      })

      $('.treehole').on('click', function() {
        $('.navBar span')
          .eq(3)
          .trigger('click')
      })

      // 提问埋点
      $('.card .ask').on('click', function(e) {
        e.preventDefault()
        let href = $(this)
          .parent('a')
          .attr('href')
        window.yxl.stat.send({
          name: '问答-「提问按钮」点击',
          properties: {
            点击位置: '问答主页'
          }
        })
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.location.href = href
        }
      })

      $('.card .clock').on('click', function(e) {
        e.preventDefault()
        let href = $(this)
          .parent('a')
          .attr('href')
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0,
            hideNavigationBar: 1
          })
        } else {
          window.location.href = href
        }
      })

      $(document).delegate('.deblock', 'click', function(e) {
        $(this)
          .siblings('.ask-detail')
          .trigger('click')
      })

      // 内容点击埋点
      $(document).delegate('.ask-detail', 'click', function(event) {
        event.preventDefault()
        if (event.originalEvent && $(this).siblings('.deblock').length) return
        let href = $(this).attr('href')
        window.yxl.stat.send({
          name: '问答-主页推荐「问题」点击'
        })
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          // window.location.href = href;
          window.open(href)
        }
        // window.location.href = href
      })

      // 内容点击埋点
      $(document).delegate('.author-title', 'click', function(event) {
        event.preventDefault()
        let href = $(this)
          .children('a')
          .attr('href')
        window.yxl.stat.send({
          name: '问答-主页推荐「问题」点击'
        })
        if (IS_APP) {
          myBridge.call('openWebView', {
            url: href,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(href)
          // window.location.href = href;
        }
        // window.location.href = href
      })

      window.onload = function() {
        showSwithFn()
      }

      $('.homeWrap .child_tab button').click(function() {
        let $this = $(this)
        let curListLenght = 0

        let statName = '答主说'
        let statType = '全部'

        $this
          .addClass('active')
          .siblings()
          .removeClass('active')
        if (type === 'newques') {
          newques_tab_num = $this.index()
          statName = '题主说'
          if (newques_tab_num) {
            switch (newques_tab_num) {
              case 1:
                statType = '星标回答'
                break
              case 2:
                statType = '0回答'
                break
              default:
                statType = '旁听'
                break
            }
          }

          page = $('.newques .child_tab button')
            .eq(newques_tab_num)
            .attr('page')
          let curList = $('.newques_ul ul').eq(newques_tab_num)
          curList
            .show()
            .siblings()
            .hide()
          showSwithFn()
          curListLenght = curList.find('li').length
        } else if (type === 'ranklist') {
          rank_tab_num = $this.index()
          statName = '实时榜单'
          if (rank_tab_num) {
            rank_tab_num === 1 ? (statType = '精华榜') : (statType = '贡献榜')
          } else {
            statType = '今日贡献榜'
          }

          let curList = $('.rank_ul ul').eq(rank_tab_num)
          page = $('.ranklist .child_tab button')
            .eq(rank_tab_num)
            .attr('page')
          curList
            .show()
            .siblings()
            .hide()
          curListLenght = curList.find('li').length
        }

        window.yxl.stat.send({
          name: statName,
          properties: {
            对象: statType,
            行为: '点击'
          }
        })

        if (curListLenght === 0 && page < 2) {
          $('.active-section')
            .parent('.rank')
            .trigger('click')
        }
      })

      $('.reward_t_bar li').click(function() {
        let $this = $(this)
        reward_tab_num = $this.index()
        let curList = $('.pageUl').eq(reward_tab_num)
        $this
          .addClass('active')
          .siblings()
          .removeClass('active')

        curList
          .addClass('active')
          .siblings()
          .removeClass('active')

        page = $this.attr('page')
        if (page < 2) {
          $('.active-section')
            .parent('.rank')
            .trigger('click')
        }
      })
      ;(function() {
        let specialsRedSpot = localStorage.specialsRedSpot
        if (!specialsRedSpot) {
          specialsRedSpot = { lastTime: null }
        } else {
          specialsRedSpot = JSON.parse(specialsRedSpot)
        }
        let date = new Date()
        let currentTime = [
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        ].join('')
        if (specialsRedSpot.lastTime !== currentTime) {
          $('.navBar span')
            .eq(5)
            .addClass('redSpot')
        }
      })()
    }

    // 加载数据
    qa.loadData = function() {
      $('.rank').on('click', function(e) {
        if (loading) return

        window.addEventListener('scroll', scroll)
        loading = true

        type = $(this).attr('attr-id')

        if (e.originalEvent) {
          if (type === 'newques') {
            $('.new-ques').hide()
          }

          $('.rank')
            .siblings()
            .children('div')
            .removeClass('active-section')
          $('.rank')
            .siblings()
            .children('.title')
            .css('font-weight', 'normal')
          setTimeout(() => {
            // ios小红点兼容问题
            $(this)
              .children('div')
              .addClass('active-section')
          })
          $(this)
            .children('.title')
            .css('font-weight', 'bold')
          $('.content')
            .children('ul')
            .css('display', 'none')
          $('.' + $(this).attr('attr-id')).css('display', 'block')
        }
        page = $(this).attr('page')
        initEle = $(this)
        // console.log($(this), type, page);
        let tag_name = 'answer'
        let tag_desc = '答主说'

        let params = { format: 'json' }
        if (type === 'newques') {
          tag_desc = '题主说'
          tag_name = 'last'
          window.localStorage['newQuesId'] = lastQuesId
          page = $('.newques .child_tab button')
            .eq(newques_tab_num)
            .attr('page')
          switch (newques_tab_num) {
            case 0:
              params.search_type = 'all'
              break
            case 1:
              params.search_type = 'star'
              break
            case 2:
              params.search_type = 'zero_answer'
              break
            default:
              params.search_type = 'pay_listen'
              break
          }
        } else if (type === 'ranklist') {
          tag_desc = '实时榜单'
          tag_name = 'rank_list'
          page = $('.ranklist .child_tab button')
            .eq(rank_tab_num)
            .attr('page')
        } else if (type === 'rewardlist') {
          tag_desc = '悬赏专区'
          tag_name = 'reward_list'
          page = $('.rewardlist .reward_t_bar li')
            .eq(reward_tab_num)
            .attr('page')
        }

        // if (type === 'ranklist') {
        //   $('.no-more').hide()
        // } else {
        //   $('.no-more').show()
        // }

        if (e.originalEvent) {
          // 用户点击的
          console.log('用户点击了')

          window.yxl.stat.send({
            name: '问答首页',
            properties: {
              对象: tag_desc,
              行为: '点击'
            }
          })

          // 神策埋点
          track.trackEvent('qa_homepage_toplist_tap', {
            button_name: tag_desc
          })

          if (page > 1) {
            loading = false
            if (type === 'ranklist') {
              window.removeEventListener('scroll', scroll)
            }
            return
          }
        } else {
          // JS代码调的
          console.log('JS点击了')
        }
        $('.loading-more').show()
        window.removeEventListener('scroll', scroll)

        // 加载新数据
        let getUrl = api.getQaData
        if (tag_name === 'rank_list') {
          getUrl = api.getRankList
          switch (rank_tab_num) {
            case 0:
              params.type = 'most_popular'
              break
            case 1:
              params.type = 'most_cream'
              break
            default:
              params.type = 'most_contribute'
              break
          }
          params.is_ajax = 1
          if (IS_APP) {
            params.token = token
          }
        } else if (tag_name === 'reward_list') {
          getUrl = api.getRewardList
          params.is_ajax = 1
          params.page = page
          if (reward_tab_num) {
            params.type = 'latest_reward_qa'
          } else {
            params.type = 'recommend_reward_qa'
          }
        } else {
          params.tag_name = tag_name
          params.page = page
          params.sshzv = sshzv
        }
        $http
          .get(getUrl, {
            params
          })
          .then(res => {
            res = res.data
            page++
            initEle.attr('page', page)
            if (type === 'newques') {
              $('.newques .child_tab button')
                .eq(newques_tab_num)
                .attr('page', page)
            } else if (type === 'ranklist') {
              $('.ranklist .child_tab button')
                .eq(rank_tab_num)
                .attr('page', page)
            } else if (type === 'rewardlist') {
              $('.rewardlist .reward_t_bar li')
                .eq(reward_tab_num)
                .attr('page', page)
            }

            if (+res.code !== 0 || !res.data || !res.data.length) {
              console.error(res.message)
              initEle.attr('isScroll', 'false')
              $('.loading-more').hide()
              window.toast('没有更多数据')
              window.removeEventListener('scroll', scroll)
              loading = false
              // showSwithFn()
              return
            } else {
              if (type === 'ranklist') {
                window.removeEventListener('scroll', scroll)
              } else {
                window.addEventListener('scroll', scroll)
              }
            }

            if (type === 'recommend') {
              $('.more-content').append(
                renderAnswerList(res.data, sshzv, unrewarded)
              )
              if (adList.length) {
                if (adList[page - 2]) {
                  let tempTemplate = adTemplate(adList[page - 2])
                  $('.more-content').append(tempTemplate)
                }
              }
            } else if (type === 'newques') {
              if (newques_tab_num === 0) {
                $('.all_data_ul').append(renderQuestionList(res.data, sshzv))
              } else if (newques_tab_num === 1) {
                $('.excellent_question_ul').append(
                  renderQuestionList(res.data, sshzv)
                )
              } else if (newques_tab_num === 2) {
                $('.none_answer_ul').append(
                  renderQuestionList(res.data, sshzv, true)
                )
              } else {
                $('.paid_listener_ul').append(
                  renderQuestionList(res.data, sshzv)
                )
              }
            } else if (type === 'ranklist') {
              switch (rank_tab_num) {
                case 0:
                  $('.ranklist-today').html(renderRankList(res.data, true))
                  break
                case 1:
                  $('.ranklist-devote').html(renderRankList(res.data))
                  break
                default:
                  $('.ranklist-essence').html(renderRankList(res.data))
                  break
              }
            } else if (type === 'rewardlist') {
              if (reward_tab_num) {
                $('.rewar_ul .latest_reward_qa').append(
                  renderRewardList(res.data)
                )
              } else {
                $('.rewar_ul .recommend_reward_qa').append(
                  renderRewardList(res.data)
                )
              }
            }
            $('.loading-more').hide()
            loading = false
            showSwithFn()
          })
          .catch(err => {
            loading = false
            $('.loading-more').hide()
            // window.toast(err)
            console.error(err)
            monitor.stat({
              level: 'error',
              error: 'api-data',
              msg: err,
              api:
                getUrl +
                '?tag_name=' +
                tag_name +
                '&page=' +
                page +
                '&sshzv=' +
                sshzv,
              apiParams: JSON.stringify({
                params
              })
            })
          })
        latestQuestion()
      })
    }

    return {
      init: qa.init,
      loadData: qa.loadData
    }
  })()

  qa.loadData()
  qa.init()

  // ab已上线
  // let HOST = getRunTime('//m.xinli001.com')
  // // 神策ABtest
  // tracks()
  //   .fetchAbtest({
  //     param_name: 'Platform_to_ask',
  //     default_value: 0,
  //     value_type: 'Number'
  //   })
  //   .then(result => {
  //     if (+result === 1) {
  //       $('#postQuesion').attr(
  //         'href',
  //         `${window.location.protocol}${HOST}/qa/postQuestionView`
  //       )
  //     }
  //   })

  // 神策埋点
  track.trackPageView('qahomepage_view', {})

  function setAppDialog() {
    if ($('.open-app-page').length === 0) {
      let appAialog = `<div class="open-app-page">打开App</div>`
      $('body').append(appAialog)

      let openApp = document.querySelector('.open-app-page')
      allToApp({
        el: openApp,
        type: 'act',
        url: window.location.href,
        errAndroidUrl: 'https://sdata.xinli001.com/t/5s',
        errIosUrl: 'https://sdata.xinli001.com/t/5s'
      })
    }
  }
})()



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/index.js